module.exports = __webpack_public_path__ + "static/media/gh.8cfe8f37.svg";